export default function getClonedFieldId(rawValue?: string) {
  const match = rawValue ? rawValue.match(/{{page_item_values.([0-9a-zA-Z_-]+)}}/) : null
  return match ? match[1] : null
}
